$(document).ready(function() { 
    // Function to get cookie value
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    // Function to set cookie
    function setCookie(name, value, options = {}) {
        options = {
            path: '/',
            ...options
        };
        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }
        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }
        document.cookie = updatedCookie;
    }

    // Function to add item to cookie
    function addItemToCookie(item) {
       let sidebarItems = getCookie('shades');
        sidebarItems = sidebarItems ? JSON.parse(sidebarItems) : [];
        const itemExists = sidebarItems.some(existingItem => existingItem.code === item.code);
    
        if (!itemExists) {
            sidebarItems.push(item);
            setCookie('shades', JSON.stringify(sidebarItems));
            updateSidebar();
        }
        jQuery('#sidebar').addClass('active');
    }

    // Function to remove item from cookie
    function removeItemFromCookie(itemId) {
        let sidebarItems = getCookie('shades');
        if (sidebarItems) {
            sidebarItems = JSON.parse(sidebarItems);
            sidebarItems = sidebarItems.filter(item => item.code !== itemId);
            setCookie('shades', JSON.stringify(sidebarItems));
            updateSidebar();
        }
    }

    // Update the sidebar with items from cookie
    function updateSidebar() {
        let sidebarItems = getCookie('shades');
        sidebarItems = sidebarItems ? JSON.parse(sidebarItems) : [];
        $('.sidebar-items').empty();
        sidebarItems.forEach(item => {
            $('.sidebar-items').append(
                `<li data-code="${item.code}" style="background:${item.color}">
                    <span class="code-name">${item.name}<span class="code">${item.code}</span></span><a class="remove-item" data-code="${item.code}"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="Icon-sc-1vqff2m-0 cyFwzO" focusable="false" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 12a.75.75 0 01.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 016.5 12z"></path></svg></a>
                 </li>`
            );
        });
        if($('.sidebar-items li').length < 1){
          $('.sidebar-items').append('<div class="no-item-found">No Shades Found</div>');
          $('button#share-items').hide();
        }else{
           $('button#share-items').show();
        }
        
    }

    // Add to sidebar button click
    $('body').on('click','.add-to-sidebar',function() {
        const $gridItem = $(this).closest('.color-swatch');
        const item = {
            code: $gridItem.data('code'),
            name: $gridItem.data('name'),
            color: $gridItem.data('color')
        };
        addItemToCookie(item);
    });

    // Remove item from sidebar
    $(document).on('click', '.remove-item', function() {
        const itemId = $(this).data('code');
        removeItemFromCookie(itemId);
    });

    // Share button functionality
    $('#share-items').on('click', function() {
      
        const sidebarItems = getCookie('shades');
        var  shareableLink = '';
        if (sidebarItems) {
            const urlParams = new URLSearchParams({ items: sidebarItems });
            var shareableLink = '/pages/shared-shades' + '?' + urlParams.toString();
            // console.log('Shareable Link: ' + shareableLink);
        } 
        const shareData = {
            title: 'Check out Shades!',
            text: 'I found this interesting, take a look:',
            url:  shareableLink // or any specific URL you'd like to share
        };

        if (navigator.share) {
            // Web Share API is supported
            navigator.share(shareData)
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing:', error));
        } else {
            // Fallback for unsupported browsers (e.g., copying the link)
            alert('Web Share not supported. You can copy the link: ' + window.location.href);
        }
    });

    jQuery('a.close-share-shade').on('click',function(){
      jQuery('#sidebar').removeClass('active');
    });

    // Initialize sidebar on page load
    updateSidebar();
});

$(document).ready(function() {
  jQuery('.grid__item.product__media-wrapper .thumbnails .product-video').click(function(){
      jQuery(this).siblings().removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.grid__item.product__media-wrapper .main-images media-gallery').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_urdu').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .dynamic-images').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .urdu-style').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product-video-container').addClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_english').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .thumbnails .english-style').removeClass('active');

  });
  jQuery('.grid__item.product__media-wrapper .thumbnails .product-image').click(function(){
      jQuery(this).addClass('active');
      jQuery('.grid__item.product__media-wrapper .main-images media-gallery').addClass('active');
      jQuery('.grid__item.product__media-wrapper .dynamic-images').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_urdu').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .urdu-style').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product-video-container,.grid__item.product__media-wrapper .thumbnails .product-video').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_english').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .thumbnails .english-style').removeClass('active');
  });
   jQuery('.grid__item.product__media-wrapper .thumbnails .urdu-style').click(function(){
      jQuery(this).addClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_urdu').addClass('active');
      jQuery('.grid__item.product__media-wrapper .dynamic-images').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .product-image').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .main-images media-gallery').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product-video-container,.grid__item.product__media-wrapper .thumbnails .product-video').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_english').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .thumbnails .english-style').removeClass('active');
  });
  jQuery('.grid__item.product__media-wrapper .thumbnails .english-style').click(function(){
      jQuery(this).addClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_english').addClass('active');
      jQuery('.grid__item.product__media-wrapper .dynamic-images').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product_image_urdu').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .urdu-style').removeClass('active')
      jQuery('.grid__item.product__media-wrapper .thumbnails .product-image').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .main-images media-gallery').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product-video-container,.grid__item.product__media-wrapper .thumbnails .product-video').removeClass('active');
  });
  jQuery('.grid__item.product__media-wrapper .dynamic-images').click(function(){
      jQuery('.grid__item.product__media-wrapper .dynamic-images').addClass('active');
      jQuery('.grid__item.product__media-wrapper .main-images media-gallery').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .product_image_urdu').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .product_image_english').removeClass('active');
     jQuery('.grid__item.product__media-wrapper .thumbnails .english-style').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .product-image').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .thumbnails .urdu-style').removeClass('active');
      jQuery('.grid__item.product__media-wrapper .product-video-container,.grid__item.product__media-wrapper .thumbnails .product-video').removeClass('active');
  });
  // Check if the popup was closed in the last 10 days
  if (!getPopupCookie('popupClosed')) {
    // Show the popup
    $('#popup').fadeIn();
  }

  // Close the popup and set the cookie when the close button is clicked
  $('#closePopup').click(function() {
    $('#popup').fadeOut();
    setPopupCookie('popupClosed', 'true', 10);  // Set the cookie for 10 days
  });
  $('a.popup-btn.button.btn.button-primary').click(function(e){
    e.preventDefault();
    $('#popup').fadeOut();
    setPopupCookie('popupClosed', 'true', 10);
    window.location.href = $(this).attr('href');
  })

  // Function to set a cookie
  function setPopupCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  // Function to get a cookie
  function getPopupCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
});





$(document).ready(function() {
  jQuery('footer.footer .col-md-3 .section-title').click(function(){
    jQuery(this).toggleClass('active');
  })

      function isColorDark(rgbString) {
        // Extract the RGB values from the 'rgb(r, g, b)' string
        const rgb = rgbString.match(/\d+/g).map(Number); // Extract numbers and convert to an array of integers
        const brightness = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
      
        return brightness > 128; // Return true if color is dark
    }
    // Function to get the URL parameter and decode the 'items' array
    function getDecodedItems() {
        const urlParams = new URLSearchParams(window.location.search);
        const items = urlParams.get('items');

        if (items) {
            return JSON.parse(decodeURIComponent(items));
        }
        return [];
    }

    // Function to create grid items
    function createGridItems(items) {
        const $gridContainer = $('.shared-shades-inner'); // The container where the grid items will be added

        $.each(items, function(index, item) {
           const darkClass = !isColorDark(item.color) ? ' dark' : '';
            var gridItem ='<div class="color-block ' + darkClass + '" style="background-color:' + item.color + ';">' +
                              '<p>' + item.name + '<span>'+ item.code +'</span></p>' +
                          '</div>';

              $gridContainer.append(gridItem);
        });
    }

    // Main logic
    const items = getDecodedItems();
    if (items.length > 0) {
        createGridItems(items);
    }
  
});


jQuery(document).ready(function(){
  jQuery('a.view-products').click(function(){
      jQuery(this).closest('.section.industrial-product-section').toggleClass('active');
       if(jQuery(this).closest('.section.industrial-product-section').hasClass('active')){
           jQuery(this).text('Hide Products');
       }else{
           jQuery(this).text('Show Products');
       }
  });
});